import React from 'react'
import styled from 'styled-components'
import { Link } from './Link'
import { STYLES } from '../../static/style'
import { DirectionsIcon } from '../Icon/DirectionsIcon'
import { Text } from '../Text'
import { LatLng } from '../../types/LatLng.types'

const StyledGoogleDirectionLink = styled(Link)`
  display: inline-block;
  margin: 0.5rem 0;
  border: 1px solid ${STYLES.PRIMARY_COLOR};
  border-radius: ${STYLES.BORDER_RADIUS};
  padding: 0 0.25rem;
`

const LinkContent = styled.div`
  display: flex;
  align-items: center;
  font-size: ${STYLES.FONT_SIZE_SM};
`

const DirectionsText = styled(Text)`
  margin-left: 0.25rem;
  font-size: ${STYLES.FONT_SIZE_SM};
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

interface IGoogleDirectionsLinkProps {
  className?: string
  coords: LatLng
}

const GoogleDirectionsLink: React.FC<IGoogleDirectionsLinkProps> = ({
  coords: { lat, lng },
  className,
}) => (
  <StyledGoogleDirectionLink
    className={className}
    title="Get directions in Google Map"
    /* or https://www.google.com/maps/dir/?api=1&destination=lat,lng */
    to={`https://maps.google.com/?daddr=${lat},${lng}`}
  >
    <LinkContent>
      <DirectionsIcon />
      <DirectionsText>Directions</DirectionsText>
    </LinkContent>
  </StyledGoogleDirectionLink>
)

export { GoogleDirectionsLink }
